import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { DataSharingService } from '../data-sharing.service';
import {HttpClient, HttpParams} from '@angular/common/http';

@Component({
  selector: 'pm-success-modal',
  templateUrl: './success-modal.component.html',
  styleUrls: ['./success-modal.component.css']
})
export class SuccessModalComponent implements OnInit {
  @Input() modalText: string; // Defines the title of the modal
  @Input() modcontent: string; // Defines the content of the modal
  @Input() disablebtn: boolean;
  @Input() reportTile: boolean;
  // Defines the enable/disable of the button
  @Input() removeBtn: boolean;
  @Output('cancelModal') cancelModal = new EventEmitter<any>(); // Emits the cancel event of the modal
  @Output() deleteModal = new EventEmitter<any>(); // Emits the delete event of the modal
  @Input() localDriverBtn: boolean;
  dialog: any;
  message: string;
  i: any;
  @Input() pageCount: any;
  @Input() users: any[];
  @Input() usersCount: any;
  @Input() pageNumber: number[]= [];
  @Input() currentPage: number;
  @Input() options: any;

  // EC-686 - toggle feature to avoid accesing /uaa/users endpoint when there is a FileUpload action
  @Input() updateUsers : boolean = false;

  constructor(public activeModal: NgbActiveModal, public router: Router, private _data: DataSharingService
  , private _httget: HttpClient) {
  }
  @Output() messageEvent = new EventEmitter<string>();
  ngOnInit() {
    if (this.updateUsers){
      //console.log('SuccessModalComponent: Updating users list (init)...');
    this._data.FileName.subscribe(message => this.message = message);
    this._data.currentUser.subscribe(users => this.users = users);
    let params = new HttpParams();
      params = params.append('page', '0')
                  .append('size', '10');
                  this._httget.get(window.location.origin + '/ftportal/uaa/api/users', { params: params, observe: 'response'})
                  .subscribe((report: any) => {
                    this.users = [];
          for (let key = 0; key < Object.keys(report.body).length; key++) {
            for (let optionlist = 0; optionlist < Object.keys(this.options).length; optionlist++) {
                if ((report.body[key].additionalInfo.split(',')[0]) === this.options[optionlist].split(' ')[0]) {
                  const file_format = report.body[key].additionalInfo.split(',')[1];
                  report.body[key].additionalInfo = this.options[optionlist] + ',' + file_format;
                   }
              }
            if (report.body[key].authorities[0] === 'ROLE_PARTNER_USER') {
                report.body[key].authorities = 'Standard';
              } else if (report.body[key].authorities[0] === 'ROLE_USER') {
                report.body[key].authorities = 'Standard';
              } else if (report.body[key].authorities[0] === 'ROLE_PARTNER_ADMIN') {
                report.body[key].authorities = 'Administrator';
              }else if (report.body[key].authorities[0] === 'ROLE_SUPER_ADMIN') {
                report.body[key].authorities = '';
              }
           this.users.push(report.body[key]);
            }
            this.usersCount = report.headers.get('X-Total-Count');
                if (this.usersCount % 10 > 0) {
                this.pageCount = Math.trunc(this.usersCount / 10 + 1);
                }else {
                    this.pageCount = this.usersCount / 10;
                }
                if (this.pageCount < 6) {
                for (this.i = 1; this.i < this.pageCount + 1; this.i++) {
                    this.pageNumber.push(this.i);
                }
            }else {
                for (this.i = 1; this.i < 6; this.i++) {
                    this.pageNumber.push(this.i);
                }
            }
                },
                error => {});
              }
  }
   public delete() {
     if (this.updateUsers){
       //console.log('SuccessModalComponent: Updating users list...');
    this.pageNumber = [];
    let params = new HttpParams();
    params = params.append('page', '0')
                .append('size', '10');
                this._httget.get(window.location.origin + '/ftportal/uaa/api/users', { params: params, observe: 'response'})
                .subscribe((report: any) => {
                  this.users = [];
                  this.usersCount = report.headers.get('X-Total-Count');
        for (let key = 0; key < Object.keys(report.body).length; key++) {
            if (report.body[key].authorities[0] === 'ROLE_PARTNER_USER') {
                report.body[key].authorities = 'Standard';
              } else if (report.body[key].authorities[0] === 'ROLE_PARTNER_ADMIN') {
                report.body[key].authorities = 'Administrator';
              }
         this.users.push(report.body[key]);
          }
        this.usersCount = report.headers.get('X-Total-Count');
        this.currentPage = 1;
                if (this.usersCount % 10 > 0) {
                this.pageCount = Math.trunc(this.usersCount / 10 + 1);
                }else {
                    this.pageCount = this.usersCount / 10;
                }
                if (this.pageCount < 6) {
                for (this.i = 1; this.i < this.pageCount + 1; this.i++) {
                    this.pageNumber.push(this.i);
                }
            }else {
                for (this.i = 1; this.i < 6; this.i++) {
                    this.pageNumber.push(this.i);
                }
            }
            this.currentPage = 1;
              },
              error => {});
              this._data.changeValue('');
              this._data.changeUser(this.users);
              this._data.changePaginationValue(this.usersCount);
              this._data.changePaginationArray(this.pageNumber);
              this._data.changePaginationNumber(this.pageCount);
              this._data.changeToFirstPage(1);
            }
    this.deleteModal.emit({});
    this.activeModal.close();
}
}


